import { Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import { AGENT_PREFER_IPV6_FIELD } from './AgentSettingsConstants';
import NgpToggle from '../../form/NgpToggle';

export default function AgentServiceTests() {
    return (
        <FormSection title={<Trans>Service Tests</Trans>}>
            <NgpToggle fieldName={AGENT_PREFER_IPV6_FIELD} label={<Trans>Prefer IPv6 for dual-stack nPoints</Trans>} />
        </FormSection>
    );
}
